/** Mission Control content modes (Sprint 4 M4). */
export const MISSION_CONTROL_MODE = Object.freeze({
  OPERATIONAL: "operational",
  DEVELOPMENT: "development",
});

const OPERATIONAL_SECTION_TITLES = new Set([
  "primary objective",
  "mission status",
  "operational status",
  "secondary objectives",
  "deployment readiness",
  "commander's notes",
  "weekly release notes",
]);

const DEVELOPMENT_SECTION_TITLES = new Set(["engineering feed"]);

function normalizeSectionTitle(title = "") {
  return String(title).toLowerCase().trim();
}

/**
 * Filter parsed MissionReady.md sections for the active Mission Control tab.
 */
export function filterMissionControlSections(sections = [], mode) {
  const titles =
    mode === MISSION_CONTROL_MODE.DEVELOPMENT
      ? DEVELOPMENT_SECTION_TITLES
      : OPERATIONAL_SECTION_TITLES;

  return sections.filter((section) =>
    titles.has(normalizeSectionTitle(section?.title)),
  );
}
